module.exports = __webpack_public_path__ + "ipetbooking/admin/img/clipboard-list.6ca1404a.svg";